<template>
    <div id="newGroupPeople">
        <div class="people-item" @click="(e) => onSelect(e)">
            <span class="people-info">
                <span class="user-segment-avatar text-center">
                    <md-highlight-text md-term="term" class="text-center">
                        {{ (row.name || "").slice(0, 1).toUpperCase() }}
                    </md-highlight-text></span
                >
                <span> {{ row.name }} </span>
            </span>
            <span class="select-people">
                <a-checkbox @click="(e) => onSelect(e)" :checked="selected" class="segment-checkbox" />
            </span>
        </div>
        <div class="line"></div>
    </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";
import { log2 } from "../../../utils/log2";

const log = log2("addNewGroup");

export default {
    name: "addNewGroup",
    props: {
        row: {
            type: Object,
            required: true,
        },
        onSelectMember: {
            type: Function,
            default: () => {},
        },
        selectedMembers: {
            type: Array,
            required: true,
        },
    },
    data() {
        return {
            selected: false,
        };
    },
    computed: {},
    methods: {
        onSelect(e) {
            e.stopPropagation();
            this.selected = !this.selected;
            this.onSelectMember();
        },
    },
    mounted() {
        this.selectedMembers.filter((item) => item._id === this.row._id).length > 0
            ? (this.selected = true)
            : (this.selected = false);
    },
    watch: {
        selectedMembers(newValue) {
            newValue.filter((item) => item._id === this.row._id).length > 0
                ? (this.selected = true)
                : (this.selected = false);
        },
    },
};
</script>

<style lang="scss">
#newGroupPeople {
    .people-item {
        display: flex;
        padding-right: 30px;
        padding-left: 15px;
        align-items: center;

        &:hover {
            background-color: #f2f2f2;
        }

        .select-people {
            width: 100%;
            justify-content: end;
            display: flex;
        }

        .people-info {
            display: flex;
            width: 100%;
            align-items: center;
        }

        .user-segment-avatar {
            height: 40px;
            width: 40px;
            display: flex;
            align-items: center;
            font-size: 16px;
            background: #6899c1;
            border-radius: 50%;
            margin-right: 15px;
        }
    }

    .line {
        border-bottom: 1px solid #f2f2f2;
        margin-bottom: 5px;
        margin-top: 5px;
    }
}
</style>
